import { Avatar, Box, Stack, Typography } from '@mui/material';
import { LinkReturnToMain } from 'Components/LinkReturnToMain';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { TAB_VALUE_TYPE } from 'Modules/UniversalRequest';
import {
  byDepartmentIcons,
  bySubjectIcons,
} from 'Modules/UniversalRequest/ParentCategoriesList';
import { FC, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

interface IContentHeader {
  isSuccessPage?: boolean;
  children: ReactNode;
  isOtp?: boolean;
  isAuth?: boolean;
  selectedCategoryId?: number | null;
  selectedSubCategoryId?: number | null;
  tabValue: number;
  parentId: number | null;
  clearCategory?: () => void;
  clearSubCategory?: () => void;
}

export const ContentHeader: FC<IContentHeader> = ({
  isSuccessPage,
  children,
  isOtp,
  isAuth,
  selectedCategoryId,
  selectedSubCategoryId,
  tabValue,
  parentId,
  clearCategory,
  clearSubCategory,
}: IContentHeader) => {
  const isDesktop = useIsDesktop();
  const dictionary = Dictionary[DICTIONARY.ContentHeader];
  const navigate = useNavigate();

  const isSubcategories =
    selectedCategoryId !== null && selectedSubCategoryId === null;
  const isUploadFiles = selectedSubCategoryId !== null && !isSuccessPage;

  const getLinkLabel = () =>
    isSubcategories || isUploadFiles ? dictionary.back : undefined;

  const getLinkClick = () => {
    if (isSubcategories && clearCategory) {
      return clearCategory();
    }
    if (isUploadFiles && clearSubCategory) {
      return clearSubCategory();
    }
    navigate('/');
  };

  const getIconById = (id: number) =>
    (tabValue === TAB_VALUE_TYPE.SUBJECTS
      ? bySubjectIcons[id]
      : byDepartmentIcons[id]) || bySubjectIcons[1];

  return (
    <Stack
      sx={{
        position: 'relative',
        padding: isDesktop ? '32px 0px 12px' : '32px 10px 0',
        bgcolor: '#FFFFFF6E',
        borderBottom: '1.76px solid',
        borderImageSource:
          'linear-gradient(110.44deg, rgba(255, 255, 255, 0.5) 1.15%, rgba(255, 255, 255, 0.23) 102.36%)',
      }}
    >
      <Stack gap={'10px'} zIndex={1}>
        {!isOtp && isAuth && isDesktop && (
          <Box
            sx={{
              position: 'absolute',
              right: '64px',
              top: '20px',
            }}
          >
            <LinkReturnToMain label={getLinkLabel()} onClick={getLinkClick} />
          </Box>
        )}
        <Stack alignItems={isDesktop ? 'center' : 'flex-start'} gap={'20px'}>
          <Stack
            direction='row'
            gap='12px'
            justifyContent={isDesktop ? 'center' : 'flex-start'}
          >
            {!!parentId && (
              <Avatar
                sx={{ width: '49px', height: '49px' }}
                alt={''}
                src={getIconById(parentId)}
              />
            )}
            <Typography
              sx={{
                fontSize: '28px !important',
                lineHeight: '37px !important',
                fontWeight: '700 !important',
              }}
              component={'h1'}
            >
              {isSuccessPage ? dictionary.successPage : dictionary.title}
            </Typography>
          </Stack>
          {children}
        </Stack>
      </Stack>
    </Stack>
  );
};
